import {routes, request} from "./"

export function createProduct (commit, product) {
    return request(commit, routes.products.createProduct, product, 'post')
}

export function updateProduct (commit, product, showload = true) {
    return request(commit, routes.products.updateProduct, product, 'post', false, showload)
}

export function updateProductListed (commit, product, showload = true) {
    return request(commit, routes.products.updateProductListed, product, 'post', false, showload)
}

export function updateProductPricing (commit, updateList) {
    return request(commit, routes.products.updateProductPricing, {'products': updateList}, 'post')
}

export function deleteProduct (commit, product) {
    return request(commit, routes.products.deleteProduct, product, 'post')
}

export function createBundle (commit, bundle) {
    return request(commit, routes.products.createBundle, bundle, 'post')
}

export function updateBundle (commit, bundle) {
    return request(commit, routes.products.updateBundle, bundle, 'post')
}

export function deleteBundle (commit, bundle) {
    return request(commit, routes.products.deleteBundle, bundle, 'post')
}

export function createCategory (commit, category) {
    return request(commit, routes.products.createCategory, category, 'post')
}

export function updateCategory (commit, category) {
    return request(commit, routes.products.updateCategory, category, 'post')
}

export function deleteCategory (commit, category) {
    return request(commit, routes.products.deleteCategory, category, 'post')
}

export function createItem (commit, item) {
    return request(commit, routes.products.createItem, item, 'post')
}

export function updateItem (commit, item) {
    return request(commit, routes.products.updateItem, item, 'post')
}

export function deleteItem (commit, item) {
    return request(commit, routes.products.deleteItem, item, 'post')
}

export function createTag (commit, tag) {
    return request(commit, routes.products.createTag, tag, 'post')
}

export function updateTag (commit, tag) {
    return request(commit, routes.products.updateTag, tag, 'post')
}

export function deleteTag (commit, tag) {
    return request(commit, routes.products.deleteTag, tag, 'post')
}

export function createProductBundle (commit, productBundle) {
    return request(commit, routes.products.createProductBundle, productBundle, 'post')
}

export function deleteProductBundle (commit, productBundle) {
    return request(commit, routes.products.deleteProductBundle, productBundle, 'post')
}

export function createProductCategory (commit, productCategory) {
    return request(commit, routes.products.createProductCategory, productCategory, 'post')
}

export function deleteProductCategory (commit, productCategory) {
    return request(commit, routes.products.deleteProductCategory, productCategory, 'post')
}

export function createProductItem (commit, productItem) {
    return request(commit, routes.products.createProductItem, productItem, 'post')
}

export function updateProductItem (commit, productItem) {
    return request(commit, routes.products.updateProductItem, productItem, 'post')
}

export function deleteProductItem (commit, productItem) {
    return request(commit, routes.products.deleteProductItem, productItem, 'post')
}

export function createProductTag (commit, productTag) {
    return request(commit, routes.products.createProductTag, productTag, 'post')
}

export function deleteProductTag (commit, productTag) {
    return request(commit, routes.products.deleteProductTag, productTag, 'post')
}

export function createProductPart (commit, productPart) {
    return request(commit, routes.products.createProductPart, productPart, 'post')
}

export function updateProductPart (commit, productPart) {
    return request(commit, routes.products.updateProductPart, productPart, 'post')
}

export function deleteProductPart (commit, productPart) {
    return request(commit, routes.products.deleteProductPart, productPart, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/products.js
// module id = 610
// module chunks = 0